import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { MaterialManagement } from './types';

export const MaterialManagementSchema = object<MaterialManagement>({
  name: string().required(() => i18n.t('validation:required')),
  codification: string().required(() => i18n.t('validation:required')),
  subCodification: string().required(() => i18n.t('validation:required')),
  typeOfMeasurement: string().required(() => i18n.t('validation:required')),
});
